import '.a{display:grid;}.ssr-plugin'
import '.gx{grid-template-columns:repeat(3, minmax(250px, 1fr));}.ssr-plugin'
import '.gy{column-gap:1.5rem;}.ssr-plugin'
import '.fx{row-gap:2rem;}.ssr-plugin'
import { useTranslations } from '@i18n/useLanguage'
import { SectionHeader } from '@app/components/blocks/sectionHeader/SectionHeader'
import { pages } from '@app/util/links'
import { InitiativeCard } from '@app/components/blocks/card/InitiativeCard'
import { useQuery } from '@based/sdk/react'
import { useMemo } from 'react'
import { InitiativeSpotlightModel } from 'functions/app/spotlight/list'
import { ListInitiativeModel } from 'functions/app/initiative/list'
import defaultProjectPicture from '@app/assets/defaultProjectPicture.png'
import { styled } from 'inlines'
import useMediaQuery from '@app/util/useMediaQuery'
import { labelAddressBuilder } from '@app/util/helpers'
import Column from '@app/components/layout/Column'

const COUNT = 5

export const DiscoverSection = () => {
  const isMobile = useMediaQuery()
  const t = useTranslations().app
  const spotlightQuery = useQuery('list-spotlight', {
    entityType: 'initiative',
    limit: COUNT,
  })
  const initiativeQuery = useQuery('list-initiative', {
    top: COUNT,
    desc: true,
  })

  const initiatives: ListInitiativeModel[] = useMemo(() => {
    const spotlights: InitiativeSpotlightModel[] = spotlightQuery.data || []

    const fallbackInitiatives: ListInitiativeModel[] =
      initiativeQuery.data || []

    const spotlighted = spotlights.map((s) => s.initiative)

    if (spotlighted.length === COUNT) {
      return spotlighted
    }

    const nonDuplicated = fallbackInitiatives.filter(
      (fi) => spotlighted.findIndex((i) => i.uuid === fi.uuid) === -1,
    )

    return [...spotlighted, ...nonDuplicated].slice(0, COUNT)
  }, [spotlightQuery.data, initiativeQuery.data])

  return (
    <Column alignItems="stretch">
      <SectionHeader
        title={t.landingPage.discoverSection.title}
        subtitle={t.landingPage.discoverSection.subTitle}
        seeMore={t.landingPage.discoverSection.seeMore}
        toRoute={pages.initiatives}
      />

      <styled.div className="a gx gy fx"
        style={{
          '@media (max-width: 1200px)': {
            gridTemplateColumns: 'repeat(2, minmax(250px, 1fr))',
          },
          '@media (max-width: 800px)': {
            gridTemplateColumns: 'repeat(1, minmax(250px, 1fr))',
          },}}
      >
        {initiatives.map((initiative, index) => {
          const isSpotlight = index === 0 && !isMobile
          return (
            <InitiativeCard
              key={initiative.slug}
              variant={isSpotlight ? 'spotlight' : 'default'}
              style={{
                gridColumn: isSpotlight ? '1 / span 2' : null,
              }}
              to={pages.initiative(initiative.slug)}
              image={initiative.images?.[0]?.src ?? defaultProjectPicture}
              title={initiative.title}
              description={isSpotlight ? initiative.description : null}
              location={labelAddressBuilder(
                initiative.location.address,
                t.common.notSpecified,
              )}
              phase={initiative.phase?.name}
              tagText={
                initiative.searchingForMembers
                  ? t.common.initiativeStatus.searchingForMembers
                  : t.common.initiativeStatus.notSearchingForMembers
              }
              tagVariant={initiative.searchingForMembers ? 'green' : 'gray'}
            />
          )
        })}
      </styled.div>
    </Column>
  )
}
